<template>
  <div>
    <!-- Text input -->
    <v-text-field
      v-if="inputType === 'text'"
      v-model="localValue"
      :label="label"
      dense
      outlined
      hide-details
    ></v-text-field>

    <!-- Number input -->
    <v-text-field
      v-else-if="inputType === 'number'"
      v-model.number="localValue"
      :label="label"
      type="number"
      dense
      outlined
      hide-details
    ></v-text-field>

    <!-- Select input -->
    <v-select
      v-else-if="inputType === 'select'"
      v-model="localValue"
      :items="options"
      :label="label"
      item-text="label"
      item-value="value"
      dense
      outlined
      hide-details
    ></v-select>
  </div>
</template>

<script>
import { FILTER_TYPES } from "../../../consts/filterTypes";

export default {
  name: "FilterValueInput",
  props: {
    value: {
      type: [String, Number, Boolean, Object],
      default: null,
    },
    field: {
      type: Object,
      required: true,
    },
    operator: {
      type: String,
      required: true,
    },
    isSecondValue: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      localValue: this.value,
    };
  },
  computed: {
    fieldType() {
      return this.field.type || "TEXT";
    },
    inputType() {
      const type = FILTER_TYPES[this.fieldType];
      return type ? type.type : "text";
    },
    options() {
      // Use field options if available, otherwise use default options from filter type
      if (this.field.options) {
        return this.field.options;
      }

      const type = FILTER_TYPES[this.fieldType];
      return type && type.options ? type.options : [];
    },
    label() {
      if (this.isSecondValue) {
        return "End Value";
      }

      if (["between", "not_between"].includes(this.operator)) {
        return "Start Value";
      }

      return "Value";
    },
  },
  watch: {
    value(newVal) {
      this.localValue = newVal;
    },
    localValue(newVal) {
      this.$emit("input", newVal);
    },
  },
};
</script>